/**
 * Módulo para el toggle de búsqueda
 * Controla la funcionalidad del botón de búsqueda y su formulario
 * Este módulo se auto-inicializa cuando el DOM está listo
 */

(function() {
    'use strict';
    
    /**
     * Inicializa la funcionalidad del toggle de búsqueda
     */
    function initSearchToggle() {
        const searchToggle = document.querySelector('#search-toggle');
        const searchForm = document.querySelector('#search-form');
        const body = document.body;
        
        if (!searchToggle || !searchForm) return;
        
        // Abrir el formulario de búsqueda
        searchToggle.addEventListener('click', function(e) {
            e.preventDefault();
            searchForm.classList.remove('hidden');
            body.classList.add('search-open'); // Evitar scroll mientras se busca
            
            // Enfocar el campo de búsqueda automáticamente
            setTimeout(() => {
                const searchInput = searchForm.querySelector('input[type="search"]');
                if (searchInput) {
                    
                    // Obtener el botón de búsqueda y su icono
                    const searchButton = searchForm.querySelector('button[type="submit"]');
                    const searchIcon = searchButton ? searchButton.querySelector('i') : null;
                    
                    // Cambiar el icono según el contenido del campo
                    if (searchInput && searchIcon) {
                        // Verificar estado inicial
                        if (searchInput.value.trim() !== '') {
                            searchIcon.className = 'bi bi-arrow-right text-[16px] text-vermelho';
                        } else {
                            searchIcon.className = 'bi bi-search text-[16px] text-vermelho';
                        }
                        
                        // Escuchar cambios en el campo
                        searchInput.addEventListener('input', function() {
                            if (this.value.trim() !== '') {
                                searchIcon.className = 'bi bi-arrow-right text-[16px] text-vermelho';
                            } else {
                                searchIcon.className = 'bi bi-search text-[16px] text-vermelho';
                            }
                        });
                    }
                }
            }, 100);
        });
        
        // Cerrar el formulario cuando se presiona la tecla Escape
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && !searchForm.classList.contains('hidden')) {
                searchForm.classList.add('hidden');
                body.classList.remove('search-open');
            }
        });
        
        // Evitar que los clics dentro del formulario lo cierren
        searchForm.addEventListener('click', function(event) {
            event.stopPropagation();
        });
        
        // Cerrar el formulario cuando se hace clic fuera de él
        document.addEventListener('click', function(event) {
            if (!searchForm.classList.contains('hidden') && 
                !searchForm.contains(event.target) && 
                !searchToggle.contains(event.target)) {
                searchForm.classList.add('hidden');
                body.classList.remove('search-open');
            }
        });
    }
    
    // Inicializar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSearchToggle);
    } else {
        initSearchToggle();
    }
})();
